module.exports = __webpack_public_path__ + "img/direct-costs-icon.ccf86ebc.svg";